import { VariantProps } from 'tailwind-variants';
import { container } from './variants';
import './styles.css';
import { useEffect, useRef } from 'react';

interface IInnerContainer extends VariantProps<typeof container> {
  data: string;
  className?: string;
}

export default function InnerHTMLContainer({
  data,
  type,
  align,
  font,
  color,
  className,
}: IInnerContainer) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const anchors = ref.current?.querySelectorAll('a');
    if (!anchors) return;

    const preventClick = (e: MouseEvent, anchor: HTMLAnchorElement) => {
      e.preventDefault();
      e.stopPropagation();
      window.open(anchor.getAttribute('href') || '', '_blank');
    };

    anchors.forEach((anchor) => {
      anchor.addEventListener('click', (e) => preventClick(e, anchor));
    });

    return () => {
      anchors.forEach((anchor) => {
        anchor.removeEventListener('click', (e) => preventClick(e, anchor));
      });
    };
  }, []);

  return (
    <div
      ref={ref}
      className={container({ type, align, font, color }) + ` ${className}`}
      dangerouslySetInnerHTML={{ __html: data || '' }}
    />
  );
}
